<template>
  <div class="main-content home">
    <div class="home-card-wrapper">
      <div class="soft-card home-project-card" style="padding: 0;">
        <div style="padding: 20px 14px 0 14px; display: flex; justify-content: space-between; align-items: center; min-height: 40px;">
          <h3 style="margin: 0; font-weight: 600;"><i class="fas fa-waveform"></i> 正在进行中的项目</h3>
          <div v-if="projects.length > 5" class="more-link" @click="viewMoreProjects" style="margin: 0;">
            查看更多项目 <i class="fas fa-arrow-right"></i>
          </div>
        </div>
        <div class="project-list-view">
          <div v-if="loading" class="loading-state">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
          <div v-else-if="projects.length === 0" class="empty-state">
            <i class="fas fa-folder-open"></i>
            <span>暂无进行中的项目</span>
          </div>
          <template v-else>
            <div v-for="project in displayProjects" :key="project.projectName" class="project-list-item">
              <div class="project-info">
                <div class="project-name">{{ project.projectName }}</div>
                <div class="project-dates">
                  <i class="far fa-calendar-alt"></i> {{ project.startTime | FormatDate('yyyy-MM-dd') }} 至
                  {{ project.endTime | FormatDate('yyyy-MM-dd') }}
                </div>
              </div>
              <div class="project-status-badge">进行中</div>
            </div>
          </template>
        </div>
      </div>

      <div class="model-card">
        <div class="feature-developing-card">
          <i class="fas fa-tools"></i>
          <span>功能正在开发中，敬请期待</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ApiService from "../service/ApiService";
import pub from "../service/public";

export default {
  name: "Home",
  data() {
    return {
      projects: [],
      loading: true,
      ongoingStatus: 400 // 默认值，会从常量中获取
    }
  },
  computed: {
    displayProjects() {
      return this.projects.slice(0, 5);
    }
  },
  mounted() {
    this.initConstOptions();
    this.fetchStats();
  },
  methods: {
    // 初始化枚举选项
    initConstOptions() {
      let constData = pub.getConst();
      if (constData) {
        // 获取项目状态枚举
        let projectStatusOptions = constData.projectStatus || [];
        // 确保是数组
        if (!Array.isArray(projectStatusOptions)) {
          console.warn('projectStatus 不是数组:', projectStatusOptions);
          return;
        }
        // 查找"进行中"对应的状态值
        let ongoingItem = projectStatusOptions.find(item => item.name === '进行中');
        if (ongoingItem) {
          this.ongoingStatus = Number(ongoingItem.value);
        }
      }
    },
    fetchStats() {
      this.loading = true;
      // 获取各项目统计数据
      // 获取正在进行的项目列表
      const params = {
        page: {number: 0, limit: 10},
        keyWord: [],
        parms: {
          status: this.ongoingStatus
        }
      };

      ApiService.ManagerProjectList(params)
        .then(res => {
          if (res.code === pub.backCode.SUCCESS) {
            this.projects = res.data.pageList || [];
          } else {
            pub.analysisReturnCode(res, null);
          }
        })
        .catch(error => {
          console.error('获取进行中项目列表失败：', error);
          this.projects = [];
          // pub.tip('获取进行中项目列表失败：', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 查看更多项目
    viewMoreProjects() {
      this.$router.push({
        path: '/projectList',
        query: {
          status: this.ongoingStatus
        }
      });
    }
  },
}
</script>

<style scoped lang="scss">
.main-content.home {
  .project-list-view {
    min-height: 480px;
  }

  .project-list-item {
    min-height: 60px;
  }

  .loading-state {
    text-align: center;
    padding: 60px 20px;
    color: #8aa79a;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    min-height: 400px;
    i {
      font-size: 24px;
      margin-bottom: 8px;
    }

    span {
      font-size: 0.9rem;
    }
  }

  .empty-state {
    text-align: center;
    padding: 60px 20px;
    color: #8aa79a;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    font-size: 0.9rem;
    min-height: 400px;

    i {
      font-size: 48px;
      margin-bottom: 8px;
    }
  }

  .model-card {
    height: 100%;
    width: 65%;
    margin-left:auto;
  }

  .feature-developing-card {
    background: #ffffffcc;
    backdrop-filter: blur(6px);
    border-radius: 32px;
    padding: 60px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    color: #8aa79a;
    font-size: 0.9rem;
    height: 100%;
    min-height: 480px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.04), 0 2px 4px rgba(0, 0, 0, 0.02);
    i {
      font-size: 48px;
      margin-bottom: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue